<div class="d-flex align-items-center " style="padding: 20px; gap: 4px;">
    <button mat-icon-button (click)="onGoParent()">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <div (click)="onGoParent()" class="mat-body-2">Camp {{itemName().toLocaleLowerCase()}}</div>
    <div style="flex:1 0 0;"></div>
    <div>
        <app-chip [hasAction]="false" [label]="'ID: '+item.id" [hasClose]="false" [filledStyle]="true"></app-chip>
    </div>
</div>
<mat-divider></mat-divider>

<app-tool-help>
    <mat-icon class="material-icons-outlined" style="overflow: visible;" helpIcon>{{icon()}}</mat-icon>
    <div helpDesc>{{helpText()}}</div>
</app-tool-help>

<mat-accordion displayMode="flat" [multi]="true">

    <mat-expansion-panel general [expanded]="true" class="mat-elevation-z81">
        <mat-expansion-panel-header>

            <mat-panel-description class="mat-body-2" style="color:unset">
                General
            </mat-panel-description>

        </mat-expansion-panel-header>

        <ng-container *ngTemplateOutlet="mainInfo"></ng-container>

    </mat-expansion-panel>
    <mat-divider *ngIf="hasDataSource()"></mat-divider>
    <mat-expansion-panel hasoptions *ngIf="hasDataSource()" [expanded]="true" class="mat-elevation-z81">

        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Opcions
            </mat-panel-description>
        </mat-expansion-panel-header>


        <ng-container *ngTemplateOutlet="options"></ng-container>

    </mat-expansion-panel>

    <mat-divider></mat-divider>

    <mat-expansion-panel *ngIf="hasValue() == null" [expanded]="false" class="mat-elevation-z81">
        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Interoperabilitat
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container *ngTemplateOutlet="interoperability"></ng-container>
    </mat-expansion-panel>
    <mat-divider></mat-divider>
    <mat-expansion-panel hasoptions *ngIf="item.type == 'CHECKBOX_ITEM' || item.type == 'SELECT_ITEM' || item.type == 'RADIO_ITEM' || item.type == 'MULTI_CHECKBOX_ITEM'" [expanded]="false"
        class="mat-elevation-z81">
        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Lògica entre camps
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container *ngIf="item.type == 'CHECKBOX_ITEM'" [ngTemplateOutlet]="logicCheckbox" [ngTemplateOutletContext]="{ $implicit: this, type: 'FIELD' }"></ng-container>
        <ng-container *ngIf="item.type == 'SELECT_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'FIELD' }"></ng-container>
        <ng-container *ngIf="item.type == 'RADIO_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'FIELD' }"></ng-container>
        <ng-container *ngIf="item.type == 'MULTI_CHECKBOX_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'FIELD'}"></ng-container>

    </mat-expansion-panel>
    <mat-divider></mat-divider>
    <mat-expansion-panel hasoptions *ngIf="(item.type == 'CHECKBOX_ITEM' || item.type == 'SELECT_ITEM' || item.type == 'RADIO_ITEM' || item.type == 'MULTI_CHECKBOX_ITEM')" [expanded]="false"
        class="mat-elevation-z81">

        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Lògica entre seccions
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container *ngIf="item.type == 'CHECKBOX_ITEM'" [ngTemplateOutlet]="logicCheckbox" [ngTemplateOutletContext]="{ $implicit: this, type: 'SECTION' }"></ng-container>
        <ng-container *ngIf="item.type == 'SELECT_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'SECTION' }"></ng-container>
        <ng-container *ngIf="item.type == 'RADIO_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'SECTION' }"></ng-container>
        <ng-container *ngIf="item.type == 'MULTI_CHECKBOX_ITEM'" [ngTemplateOutlet]="logicSelect" [ngTemplateOutletContext]="{ $implicit: this, type: 'SECTION'}"></ng-container>

    </mat-expansion-panel>


</mat-accordion>

<ng-template #logicCheckbox let-name let-type="type">

    @let _logic = type == 'SECTION' ? name.logicShowHideSectionArray : name.logicShowHideFieldArray;
    @let _remove = type == 'SECTION' ? name.removeLogicSection : name.removeLogicField;
    @let _add = type == 'SECTION' ? name.addLogicSection : name.addLogicField;

    <ng-container *ngFor="let logic of _logic(),let index = index">
        <div class="d-flex" style="padding-bottom: 20px;">
            <div class="d-flex flex-column" style="flex: 1 0 0;">
                <app-single-field label="Mostra la secció amb identificador"
                    toolTipMsg="Introdueix el identificador de la secció"
                    [fieldValue]="logic.ref"
                    (fieldValueChange)="logic.ref = $event;fireChange();">
                </app-single-field>
                <app-single-field
                    [label]="'Quan estigui '+( logic.value == true ?'chequejat':'sense chequejar') "
                    type="checkbox" toolTipMsg="" [fieldValue]="logic.value"
                    (fieldValueChange)="logic.value = $event;fireChange();">
                </app-single-field>
            </div>
            <div class="d-flex align-items-center">
                <button mat-icon-button (click)="_remove(index)">
                    <mat-icon class="material-icons-outlined">remove_circle_outline</mat-icon>
                </button>
            </div>
        </div>
        <div style="padding-right: 40px; padding-bottom: 16px;">
            <mat-divider></mat-divider>
        </div>

    </ng-container>
    <div class="d-flex align-items-center">
        <button mat-icon-button (click)="_add()">
            <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
        </button>
    </div>

</ng-template>

<ng-template #logicSelect let-name let-type="type">

    @let _logic = type == 'SECTION' ? name.logicShowHideSectionArray : name.logicShowHideFieldArray;
    @let _remove = type == 'SECTION' ? name.removeLogicSection : name.removeLogicField;
    @let _add = type == 'SECTION' ? name.addLogicSection : name.addLogicField;

    <ng-container *ngFor="let logic of _logic(),let index = index">
        
        <div class="d-flex" style="padding-bottom: 20px;">

            <div class="d-flex flex-column" style="flex: 1 0 0;">
                <app-single-field label="Mostra la secció amb identificador"
                    toolTipMsg="Introdueix el identificador de la secció" [fieldValue]="logic.ref"
                    (fieldValueChange)="logic.ref = $event;fireChange();">
                </app-single-field>
                <app-single-field [label]="'Quan estigui seleccionat'"
                    type="text" toolTipMsg="Quan el select tingui el valor " [fieldValue]="logic.value"
                    (fieldValueChange)="logic.value = $event; fireChange();">
                </app-single-field>
            </div>
            <div class="d-flex align-items-center">
                <button mat-icon-button (click)="_remove(index)">
                    <mat-icon class="material-icons-outlined">remove_circle_outline</mat-icon>
                </button>
            </div>

        </div>
        <div style="padding-right: 40px; padding-bottom: 16px;">
            <mat-divider></mat-divider>
        </div>

    </ng-container>
    <div class="d-flex align-items-center">
        <button mat-icon-button (click)="_add()">
            <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
        </button>
    </div>

</ng-template>

<ng-template #mainInfo>

    <div class="d-flex flex-column">

        <app-single-field label="Nom"
            toolTipMsg="Introdueix el nom del camp del formulari. Aquest és el títol del camp que l'usuari veurà en completar el formulari."
            [fieldValue]="item.fieldLabel" (fieldValueChange)="item.fieldLabel = $event;fireChange();">
        </app-single-field>

        <app-single-field *ngIf="hasValue() == null" label="Missatge d'ajuda"
            toolTipMsg="Introdueix el missatge d'ajuda del camp de formulari. Això es mostrarà a l'usuari i proporcionarà indicacions sobre com s'ha de completar o seleccionar el camp."
            [fieldValue]="item.hint" (fieldValueChange)="item.hint = $event;fireChange();">
        </app-single-field>

        <app-single-field *ngIf="hasValue() == null" label="Requerit" type="checkbox"
            toolTipMsg="Selecciona aquesta opció perquè el camp del formulari sigui obligatori. Un camp obligatori impedirà que s'enviï el formulari si no es completa o selecciona."
            [fieldValue]="item.required" (fieldValueChange)="item.required = $event;fireChange();">
        </app-single-field>

        <app-single-field label="Només lectura" type="checkbox"
            toolTipMsg="Fes un camp amb un valor fixe que l'usuari no pot modificar"
            [fieldValue]="item.readonly" (fieldValueChange)="item.readonly = $event;fireChange();">
        </app-single-field>

        <app-single-field *ngIf="hasLength() && hasValue() == null " label="Longitud Màxima" type="numeric"
            toolTipMsg="Introdueix el nombre màxim de caràcters que pot tenir aquest camp."
            [fieldValue]="hasLength() == null ? 0: LengthItemMetadata().maxLength"
            (fieldValueChange)="LengthItemMetadata().maxLength = $event;fireChange();">
        </app-single-field>

        <app-single-field *ngIf="hasValue()" label="Contingut" type="textarea"
            toolTipMsg="Introdueix el contigut del camp (html permes)" [fieldValue]="ValueItemMetadata().value"
            (fieldValueChange)="ValueItemMetadata().value = $event;fireChange();">
        </app-single-field>

        <ng-container *ngTemplateOutlet="defaultValue"></ng-container>

        <app-single-field *ngIf="item.type == 'TEXT_ITEM'" label="Validació" type="select" 
            toolTipMsg="Selecciona la validació d'aquest camp"
            [options]="getGenericValidations()"
            [deleteSelector]="true"
            [fieldValue]="item.validatorName" (fieldValueChange)="item.validatorName = $event; fireChange();">
        </app-single-field>

    </div>

</ng-template>

<ng-template #defaultValue>

    <ng-container [ngSwitch]="item.type">
        <ng-container *ngSwitchCase="'TEXT_ITEM'">
            <app-single-field label="Valor per defecte" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event;fireChange();">
            </app-single-field>
        </ng-container>
        <ng-container *ngSwitchCase="'NUMERIC_ITEM'">
            <app-single-field label="Valor per defecte" type="numeric" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event;fireChange();">
            </app-single-field>
        </ng-container>
        <ng-container *ngSwitchCase="'TEXTAREA_ITEM'">
            <app-single-field label="Valor per defecte" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event;fireChange();">
            </app-single-field>
        </ng-container>

        <ng-container *ngSwitchCase="'CHECKBOX_ITEM'">
            <app-single-field label="Valor per defecte" type="checkbox" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event;fireChange();">
            </app-single-field>
        </ng-container>

        <ng-container *ngSwitchCase="'DATEPICKER_ITEM'">
            <app-single-field label="Valor per defecte" type="datepicker" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event; fireChange();">
            </app-single-field>
        </ng-container>
        <ng-container *ngSwitchCase="'TIME_ITEM'">
            <app-single-field label="Valor per defecte" type="time" toolTipMsg="Valor per defecte del camp"
                [fieldValue]="item.defaultValue" (fieldValueChange)="item.defaultValue = $event;fireChange();">
            </app-single-field>
        </ng-container>
        <ng-container *ngSwitchCase="'RADIO_ITEM'">
            <ng-container *ngTemplateOutlet="null"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'MULTI_CHECKBOX_ITEM'">
            <ng-container *ngTemplateOutlet="null"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'SELECT_ITEM'">
            <ng-container *ngTemplateOutlet="null"></ng-container>
        </ng-container>

    </ng-container>

</ng-template>

<ng-template #interoperability>
    <div class="d-flex flex-column">

        <app-single-field label="Nom al JSON" [validator]="fieldNameValidator"
            toolTipMsg="Es el nom que identifica al camp en el format JSON, per tant no pot començar per una lletra, tenir espais i els caràcters han de ser alfanumérics"
            [fieldValue]="item.fieldName" (fieldValueChange)="updateFiledName($event);fireChange();">
        </app-single-field>

    </div>
</ng-template>


<ng-template #options>

    <ng-container *ngIf="isSelect()">
        <mat-slide-toggle [(ngModel)]="itemHasFamily" [checked]="hasFamily() || itemHasFamily" [disabled]="hasFamily()">

            <app-help-label toolTipMsg="Activa la dependencia entre selects">
                Selector dependent
            </app-help-label>

        </mat-slide-toggle>
        <div style="padding-top: 16px;">
            Estableix la relació de dependència entre els camps selectors.
        </div>
    </ng-container>


    <ng-container *ngIf="itemHasFamily || hasFamily() " [ngTemplateOutlet]="familyTemplate"></ng-container>

    <mat-radio-group *ngIf="itemHasFamily==false && hasFamily() == false" aria-label="Select an option">

        <div style="padding-bottom: 16px;">Defineix les opcions per a aquest camp.</div>

        <div class="d-flex flex-column" cdkDropList [cdkDropListData]="DataSourceItemMetadata().options" (cdkDropListDropped)="drop($event)" 
             cdkDropListOrientation="vertical" [class.dd-container]="onDD">
            <div class="d-flex flex-column" *ngFor="let option of DataSourceItemMetadata().options; let index = index" cdkDrag
                [class.dd-widget]="onDD" (cdkDragStarted)="startDD($event)" (cdkDragEnded)="endDD($event)">

                <div class="d-flex align-items-center justify-content-between" style="width:100%;">

                    <div style="padding-top: 5px; cursor: move;" cdkDragHandle>
                        <mat-icon class="material-icons-outlined">drag_handle</mat-icon>
                    </div>

                    <div>
                        <mat-radio-button *ngIf="isMultipleCheckBox()==false"
                            [checked]="option.value == item.defaultValue" [value]="option.value"
                            (change)="item.defaultValue = option.value;fireChange();"></mat-radio-button>
                        <mat-checkbox *ngIf="isMultipleCheckBox()==true" [checked]="getDefaultValueCB(option)"
                            (change)="changeDefaultValueCB($event,option);fireChange();"></mat-checkbox>
                    </div>

                    <app-single-field [fieldValue]="option.value" style="padding-top: 16px;"
                        (fieldValueChange)="deleteOptionValueCB(option);option.value = $event;option.id = $event;createDefaultCBOption(option);fireChange();">
                    </app-single-field>
                    <div>
                        <button (click)="removeOption(option)" mat-icon-button>
                            <mat-icon class="material-icons-outlined">remove_circle_outline</mat-icon>
                        </button>
                    </div>
                    <div>
                        <button (click)="addOption(index)" mat-icon-button>
                            <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
                        </button>
                    </div>

                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button (click)="addOption(DataSourceItemMetadata().options.length)" mat-icon-button>
                    <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
                </button>
            </div>
        </div>
    </mat-radio-group>
</ng-template>

<ng-template #familyTemplate>
    <app-chained-select-metadata-editor (changeItem)="refresh();changeItem.emit($event);"
        [item]="DataSourceItemMetadata()">

    </app-chained-select-metadata-editor>
</ng-template>